import { customerBaseApi } from "@/react/services/api/api";
import { KEY } from "@/react/components/table/useTableMutations";

import schema from "./schema";
import { PHONE_CHANNELS } from "../constants";
import { phoneChannelsPath } from "../urls";
import { handleMutationResponse } from "@/react/services/api/handleMutationResponse";

import { createNotifier } from "@/react/notifications";

export const phoneChannelsApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    // Since there is not GetAll on Phone Channels, a search should be initiated with an empty body to mimic a GetAll
    getPhoneChannels: build.query({
      query: (tenantName) => ({
        url: phoneChannelsPath(tenantName),
        method: "POST",
        body: {},
      }),
      providesTags: [PHONE_CHANNELS],
    }),
    updatePhoneChannels: build.mutation({
      query: ({ tenantName, phoneChannels }) => ({
        url: phoneChannelsPath(tenantName),
        method: "PUT",
        body: phoneChannels,
      }),
      invalidatesTags: [PHONE_CHANNELS],
    }),
  }),
});

export const { useGetPhoneChannelsQuery, useUpdatePhoneChannelsMutation } =
  phoneChannelsApi;

export const handleUpdateResponse = ({
  rowsToUpdate,
  setRowsToUpdate,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToUpdate,
    setRows: setRowsToUpdate,
    setData,
    responseMappingKey: schema.fields.id.spec.key,
    idKey: KEY,
    notifyContent: createNotifier("update", "phone channel"),
  });
